import React from 'react';
import HelpPageShell from '../../components/help/HelpPageShell';
import { homeownerHelpContent } from '../../content/help/homeownerHelpContent';
import { homeownerWalkthroughAssets } from '../../content/help/homeownerWalkthroughAssets';
import { getHelpDownloadByRole } from '../../content/help/helpDownloads';

interface HomeownerHelpPageProps {
  onNavigate: (screen: string) => void;
}

export default function HomeownerHelpPage({ onNavigate }: HomeownerHelpPageProps) {
  const origin = React.useMemo(() => {
    try { return sessionStorage.getItem('cb.help.origin') || 'customer-dashboard'; } catch { return 'customer-dashboard'; }
  }, []);

  const backLabel = origin === 'customer-dashboard' ? '← Back to Dashboard' : '← Back';

  const handleBack = () => {
    try { sessionStorage.removeItem('cb.help.origin'); } catch {}
    onNavigate(origin);
  };

  return (
    <div>
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '10px 24px' }}>
        <button
          onClick={handleBack}
          style={{
            background: 'none',
            border: '1px solid #cbd5e1',
            borderRadius: 8,
            padding: '7px 14px',
            fontSize: 14,
            fontWeight: 600,
            color: '#334155',
            cursor: 'pointer',
          }}
        >
          {backLabel}
        </button>
      </div>
      <HelpPageShell
        role="homeowner"
        title="Help Center"
        subtitle="Step-by-step help for submitting projects, reviewing bids, payments, milestones, and completion."
        sections={homeownerHelpContent}
        assets={homeownerWalkthroughAssets}
        downloadConfig={getHelpDownloadByRole('homeowner')}
        pendingSectionStorageKey="cb.help.section"
      />
    </div>
  );
}
